<template>
  <div class="pay">
    <van-nav-bar
      fixed
      placeholder
      title="支付"
    />

    <div class="main-wrap">
      <div class="success-img">
        <img src="@/assets/success.png" />
      </div>
      <div class="success-title"  >支付成功</div>
    </div>


<!-- 
    <div  class="order-wrap">

      <div class="payInfoItem">
        <div>支付金额：</div>
        <div>{{ 'payData.orderNo' }}</div>
      </div>
      <div class="payInfoItem">
        <div>订单编号：</div>
        <div>{{ 'payData.orderNo' }}</div>
      </div>

      <div class="payInfoItem">
        <div>支付时间：</div>
        <div>{{ 'payData.payTime' }}</div>
      </div>
    </div> -->
    

    <div class="btn"  @click="goBack">
      <span>确定</span>
    </div>

    <div class="footer-wrap">
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {
      payType: "1",
      password: "",
    };
  },

  components: {
    Footer,
  },

  computed: {
    // return
    time() {
      let t = 1648468800 - new Date().getTime() / 1000;

      return t * 1000;
    },
  },
  methods: {
   
   

    goBack() {
      // this.$router.replace("/contribute");
      this.$router.replace("/order");
    },
  },
  created() {
  
  },
};
</script>

<style lang="less" scoped>
.pay {
  background: #fff;
  height: 100vh;
  padding: 10px;
  .main-wrap {
    .success-img {
      display: flex;

      justify-content: center;

      align-items: center;
      img {
        width: 100px;
     height: 100px;
        border-radius: 4px;
      }
    }

    .success-title {
      font-size: 16px;
      color: #333;
      text-align: center;
      padding: 20px 0;
    }


  }


   .order-wrap {
     background: #f9f9f9 !important;

    padding: 20px;

    .payInfoItem {
      display: flex;
      align-items: center;
      font-size: 12px;

      color: #666;
      margin-bottom: 10px;
      // > div:first-child {
      //   margin-bottom: 15px;
      //   font-weight: bold;
      // }
    }
  }

  .btn {
    line-height: 40px;

    background: #ff991d;
    border-radius: 20px;

    text-align: center;
    color: #fff;
    display: flex;

    justify-content: center;
    align-items: center;
    margin: 30px 30px;
  }

  .footer-wrap {
    position: absolute;
    bottom: 15px;
    transform: translateX(50%);
  }
}
</style>